import { useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import CloseIcon from "@material-ui/icons/Close";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import React, { useContext, useState, useEffect } from "react";
import { ProcessGrapqlError } from "..";
import { Context } from "../store";
import { AlertDialog, HalfScreenDialog } from "../_components";
import { AlertHelper, LoaderHelper } from "../_helpers";
import { GET_ROUTER_DETAILS } from "../_queries";
import { useRouter } from "../hooks";
import { Colors } from "../_constants";
import { UpdateRouter } from "../_components/router/UpdateRouter";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    "& > *": {
      marginRight: theme.spacing(1),
    },
  },
  table: {
    minWidth: 650,
  },
  bredcrumb: {
    backgroundColor: `${Colors.WHITE}`,
    marginBottom: "15px",
    borderRadius: "5px",
  },
  bredcrumbTitle: {
    fontSize: "16px",
    fontWeight: "600",
  },
  tableHeader: {
    backgroundColor: `${Colors.SECONDARY_LIGHT}`,
    padding: "15px",
  },
}));
export const Router = () => {
  const classes = useStyles();
  const { state, setGlobalState } = useContext(Context);
  const [deleting, setDeleting] = useState(false);
  const [ref_id, setRefId] = useState("0");
  const { GetRouter, DeleteRouterDetails } = useRouter();

  useEffect(() => {
    GetRouter();
  }, [GetRouter]);

  const Delete = (id) => {
    setRefId(id);
    setDeleting(true);
  };
  const Negative = () => {
    setRefId("0");
    setDeleting(false);
  };
  const Positive = () => {
    setDeleting(false);
    AlertHelper.progress("Deleting...");
    DeleteRouterDetails({
      variables: { router_id: ref_id },
      update(cache) {
        const existing = cache.readQuery({ query: GET_ROUTER_DETAILS });
        const newRouter = existing.GetRouterDetails.filter(
          (item) => item.router_id !== ref_id
        );
        cache.writeQuery({
          query: GET_ROUTER_DETAILS,
          data: { GetRouterDetails: newRouter },
        });
      },
    });
  };

  const DataLists = () => {
    const { loading, error, data } = useQuery(GET_ROUTER_DETAILS);
    if (loading) {
      LoaderHelper.load();
    } else {
      LoaderHelper.clear();
    }
    if (error) {
      ProcessGrapqlError(error);
    }

    return (
      <>
        <List className={classes.bredcrumb}>
          <ListItem>
            <ListItemText
              primary={<span className={classes.bredcrumbTitle}>Router</span>}
              secondary="Add Router Here"
            />
            <ListItemSecondaryAction>
              <Button
                startIcon={<AddBoxIcon />}
                onClick={() => {
                  setGlobalState({
                    ...state,
                    router_adding: true,
                    editing_router: false,
                  });
                }}
                variant={"text"}
                color={"primary"}
              >
                Add New
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                {/* <TableCell className={classes.tableHeader}>Router ID</TableCell> */}
                <TableCell className={classes.tableHeader}>
                  Router Name
                </TableCell>
                <TableCell className={classes.tableHeader}>Link</TableCell>
                <TableCell className={classes.tableHeader}>
                  Valid Till
                </TableCell>
                <TableCell className={classes.tableHeader}>
                  Sweepstakes
                </TableCell>
                <TableCell className={classes.tableHeader}>Users</TableCell>
                <TableCell className={classes.tableHeader}>Action</TableCell>
                <TableCell className={classes.tableHeader}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.GetRouterDetails.map((router) => (
                  <TableRow key={router.router_id}>
                    {/* <TableCell component="th" scope="row">
                      {router.router_id}
                    </TableCell> */}
                    <TableCell component="th" scope="row">
                      {router.router_name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {router.router_link}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {router.router_end_date_time}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {router.sweepstake_title}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {router.user_count}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => {
                          setGlobalState({
                            ...state,
                            edit_router: router,
                            editing_router: true,
                            router_adding: true,
                          });
                        }}
                        aria-label="delete"
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => Delete(router.router_id)}
                        aria-label="delete"
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };
  return (
    <>
      {deleting && (
        <AlertDialog
          open={true}
          negative={Negative}
          positive={Positive}
          title={"Warning"}
          description={"Are you sure you want to delete?"}
        />
      )}
      {state.router_adding && (
        <HalfScreenDialog
          open={true}
          component={<UpdateRouter />}
          CloseCallback={() => {
            setGlobalState({
              ...state,
              router_adding: false,
            });
          }}
        />
      )}
      <Container maxWidth={false}>
        <Box className={classes.container}>
          <DataLists />
        </Box>
      </Container>
    </>
  );
};
